module.exports = __webpack_public_path__ + "img/close-line.e03fdd35.svg";